import { render } from "./PropertyDetailsPage.vue?vue&type=template&id=3970658b&ts=true"
import script from "./PropertyDetailsPage.vue?vue&type=script&lang=ts"
export * from "./PropertyDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__